import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class adminUsers {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.sendPositionSubject = new BehaviorSubject([]);
        this.sendPositioObservable = this.sendPositionSubject.asObservable();
    }
    addExternalUser(json) {
        return this.httpClient.post(environment.api.base + 'ExternalUser/AddExternalUser', json);
    }
    upDateExternalUser(json) {
        return this.httpClient.put(environment.api.base + 'ExternalUser/UpdateExternalUser', json);
    }
    daleteExternalUser(json) {
        return this.httpClient.post(environment.api.base + 'ExternalUser/DeleteExternalUser', json);
    }
    getExternalUserList() {
        return this.httpClient.get(environment.api.base + 'ExternalUser/GetExtenalUserList');
    }
    bulkLoad(json) {
        return this.httpClient.post(environment.api.base + 'ExternalUser/BulkLoad', json);
    }
}
adminUsers.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function adminUsers_Factory() { return new adminUsers(i0.ɵɵinject(i1.HttpClient)); }, token: adminUsers, providedIn: "root" });
